import React, {useState} from 'react'

import DomainTablePage from '../../components/domainTablePage.js'
import {CategoryWebsitesPageResult} from '../../../../server/routes/technology-type.js'

interface CategoryWebsitesProps {
	server: string;
	pageData: unknown;
}

export default function CategoryWebsites({server, pageData}: CategoryWebsitesProps) {

	const typedPageData = pageData as CategoryWebsitesPageResult;
	const [data, setData] = useState(typedPageData);

	return (
        <DomainTablePage 
            domainList={data.TechnologyDomains}
        />
	)
}
